/* 1) Bolinhas (dots) para os sliders de USP em mobile */
(function () {
  var MQ = '(max-width: 749px)';

  function buildDots(grid) {
    if (grid.dataset.sjDots === '1') return;
    var items = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.classList && el.classList.contains('grid-item');
    });
    if (items.length < 2) return;
    grid.dataset.sjDots = '1';

    var dots = document.createElement('div');
    dots.className = 'sj-dots';

    items.forEach(function (item, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sj-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Element ' + (i + 1));
      dot.addEventListener('click', function () {
        grid.scrollTo({ left: item.offsetLeft - grid.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(dot);
    });

    grid.parentNode.insertBefore(dots, grid.nextSibling);

    var timer;
    grid.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var best = Infinity;
        var index = 0;
        items.forEach(function (item, i) {
          var delta = Math.abs(item.offsetLeft - grid.offsetLeft - grid.scrollLeft);
          if (delta < best) { best = delta; index = i; }
        });
        Array.prototype.slice.call(dots.children).forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }, 60);
    }, { passive: true });
  }

  function init() {
    if (window.matchMedia && !window.matchMedia(MQ).matches) return;
    document.querySelectorAll('.grid.multicolumn').forEach(buildDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  window.addEventListener('resize', function () { setTimeout(init, 200); });
})();

/* 2) Carrossel de avaliacoes: cartao central + avanco automatico a cada 5s */
(function () {
  var DELAY = 5000;
  var PAUSE_AFTER_TOUCH = 9000;

  function centerOf(track, card) {
    return card.offsetLeft - (track.clientWidth - card.clientWidth) / 2;
  }

  function currentIndex(track) {
    var center = track.scrollLeft + track.clientWidth / 2;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < track.children.length; i++) {
      var c = track.children[i];
      var dist = Math.abs(c.offsetLeft + c.clientWidth / 2 - center);
      if (dist < bestDist) { bestDist = dist; best = i; }
    }
    return best;
  }

  function setup(track) {
    if (track.dataset.sjAuto === '1') return;
    var cards = track.children;
    if (cards.length < 2) return;
    track.dataset.sjAuto = '1';

    // O primeiro cartao arranca centrado, com os vizinhos a espreitar dos lados
    requestAnimationFrame(function () {
      track.scrollLeft = centerOf(track, cards[0]);
    });

    var paused = false;
    var resumeTimer;
    function pause() {
      paused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; }, PAUSE_AFTER_TOUCH);
    }
    ['mouseenter', 'touchstart', 'pointerdown', 'wheel'].forEach(function (evt) {
      track.addEventListener(evt, pause, { passive: true });
    });
    track.addEventListener('mouseleave', function () {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; }, 1200);
    });

    setInterval(function () {
      if (paused || document.hidden) return;
      var next = (currentIndex(track) + 1) % cards.length;
      track.scrollTo({ left: centerOf(track, cards[next]), behavior: 'smooth' });
    }, DELAY);
  }

  function init() {
    document.querySelectorAll('[id^="rvTrack-"]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();

/* 3) Pagina de produto: caixa "Expedie le" passa para debaixo dos icones de pagamento */
(function () {
  function move() {
    var wraps = document.querySelectorAll('.form__width');
    for (var w = 0; w < wraps.length; w++) {
      var kids = wraps[w].children;
      var ul = null;
      var box = null;
      for (var i = 0; i < kids.length; i++) {
        if (!ul && kids[i].tagName === 'UL' && kids[i].querySelector('svg[aria-labelledby^="pi-"]')) {
          ul = kids[i];
        }
        var st = kids[i].getAttribute ? kids[i].getAttribute('style') : null;
        if (!box && st && st.indexOf('#f7f7f7') > -1) {
          box = kids[i];
        }
      }
      if (ul && box && box.dataset.sjMoved !== '1') {
        box.dataset.sjMoved = '1';
        ul.parentNode.insertBefore(box, ul.nextSibling);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', move);
  } else {
    move();
  }
  window.addEventListener('load', move);
})();
